import { inject, Injectable } from '@angular/core';
import { createTitle } from '@shared/utils/helpers';
import { Message, MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly messageService = inject(MessageService);

  public open(
    detail: string,
    title?: string,
    severity: Message['severity'] = 'success',
  ): void {
    this.messageService.add({
      severity,
      summary: title ? title : createTitle(severity ?? ''),
      detail,
      key: 'main',
    });
  }
}
